import { createBrowserHistory } from 'history';

// export default createBrowserHistory();
export default createBrowserHistory({ window });

// const { createMemoryHistory } = require("history");
// export default createMemoryHistory();